import {SAVE_NEW_STREAM, GET_STREAM, GET_CONFIG_ACTION} from '../constants/actionTypes';
import objectAssign from 'object-assign';
import initialState from './initialState';

// IMPORTANT: Note that with Redux, state should NEVER be changed.
// State is considered immutable. Instead,
// create a copy of the state passed and set new values on the copy.
// Note that I'm using Object.assign to create a copy of current state
// and update values on the copy.
export default function streamConfigReducer(state = initialState.streamConfig, action) {
  let newState;

  switch (action.type) {

    case SAVE_NEW_STREAM:
      if(action.error){
        if(action.error.fields) {
          newState = objectAssign({}, state, {validationError: action.error});
        } else {
          newState = objectAssign({}, state, {error: action.error, validationError: false});
        }
      }
      else{
        newState = objectAssign({}, state, {message: action.message, validationError: false})
      }
      return newState;

    case GET_STREAM:
    if(action.error){
      newState = objectAssign({}, state, {error: action.error});
    }
    else{
      newState = objectAssign({}, state, {container: action.container})
    }
    return newState;

    case GET_CONFIG_ACTION:
      newState = objectAssign({}, state, {...action.payload})
    return newState;

    default:
      return state;
  }
}
